/* eslint-disable */
import React from "react";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend
);

// color palette (auto-rotates if data is more)
const COLORS = [
    "#6F94C9",
    "#EF4444",
    "#22C55E",
    "#f59e0b",
    "#0ea5e9",
    "#9333ea",
    "#14b8a6",
];

const OverallBarChart = ({
    labels = [],
    data = [],
    height = 300,
}) => {
    const maxValue = Math.max(...data, 0);

    const chartData = {
        labels,
        datasets: [
            {
                data,
                backgroundColor: data.map(
                    (_, index) => COLORS[index % COLORS.length]
                ),
                borderRadius: 6,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { display: false },
            tooltip: {
                enabled: true,
            },
            datalabels: {
                display: true,
                color: "#000",
                anchor: "end",
                align: "top",
                offset: 4,
                font: {
                    size: 11,
                    weight: "bold",
                },
                formatter: (value) => (value > 0 ? value : ""),
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                max: maxValue + 20,
                ticks: {
                    stepSize: 40,
                },
            },
        },
    };

    return (
        <div style={{ height }}>
            <Bar data={chartData} options={options} />
        </div>
    );
};

export default OverallBarChart;
